import { useCMSApiQuery } from '../../hooks/useCMSApiQuery';

export function useSocialMedias(locale: string) {
  const query = useCMSApiQuery<GetSocialMediaResponseTO>(
    '/cms/v1/social-medias',
    {
      culture: locale,
    }
  );
  return query.data;
}

type GetSocialMediaResponseTO = {
  appStore: SocialMediaTO[];
  socialMedia: SocialMediaTO[];
};

type SocialMediaTO = {
  iconImage: string;
  name: string;
  url: string;
};
